<template>
  <div class="nav-page">

    <!-- Hero -->
    <section class="nav-page__hero">
      <div class="nav-page__shell">
        <span class="nav-page__hero-badge">
          <i class="fas fa-gift"></i>
          {{ $t('blog.blog4.endow') }}
        </span>
        <h1 class="nav-page__hero-title">
          <span class="nav-page__hero-title--gold">{{ $t('blog.blog5.donate50') }}</span>
          <span>{{ $t('blog.blog5.newCus') }}</span>
          <em>{{ $t('blog.blog5.inVantage') }}</em>
        </h1>
        <p class="nav-page__hero-sub">{{ $t('blog.blog5.endow') }}</p>
      </div>
    </section>

    <main class="nav-page__main">
      <div class="nav-page__shell">

        <!-- Bonus cards -->
        <div class="nav-page__bonus-grid">
          <div class="nav-page__bonus-card">
            <div class="nav-page__bonus-icon nav-page__bonus-icon--teal">
              <i class="fas fa-user-plus"></i>
            </div>
            <div>
              <h3>{{ $t('blog.blog5.newAcc') }}</h3>
              <p class="nav-page__bonus-amount nav-page__bonus-amount--green">{{ $t('blog.blog5.receive10') }}</p>
              <em class="nav-page__bonus-note">{{ $t('blog.blog5.noteActive') }}</em>
            </div>
          </div>
          <div class="nav-page__bonus-card">
            <div class="nav-page__bonus-icon nav-page__bonus-icon--purple">
              <i class="fas fa-handshake"></i>
            </div>
            <div>
              <h3>{{ $t('blog.blog5.introducer') }}</h3>
              <p class="nav-page__bonus-amount nav-page__bonus-amount--purple">{{ $t('blog.blog5.also10') }}</p>
              <em class="nav-page__bonus-note">{{ $t('blog.blog5.noteActive') }}</em>
            </div>
          </div>
        </div>

        <!-- More bonuses -->
        <div class="nav-page__more-box">
          <h2 class="nav-page__box-title">{{ $t('blog.blog5.moreEndow') }}</h2>
          <div class="nav-page__more-grid">
            <div class="nav-page__more-card nav-page__more-card--orange">
              <div class="nav-page__more-icon">
                <i class="fas fa-wallet"></i>
              </div>
              <h3>{{ $t('blog.blog5.vantageBonus') }}</h3>
              <strong>20$</strong>
              <p>{{ $t('blog.blog5.first') }}</p>
            </div>
            <div class="nav-page__more-card nav-page__more-card--indigo">
              <div class="nav-page__more-icon">
                <i class="fas fa-crown"></i>
              </div>
              <h3>{{ $t('blog.blog5.customerSpecial') }}</h3>
              <strong>50$</strong>
              <p>{{ $t('blog.blog5.setupEA') }}</p>
            </div>
          </div>
        </div>

        <!-- Video -->
        <div class="nav-page__video-wrap">
          <div class="nav-page__video-inner">
            <video controls preload="metadata" autoplay muted loop playsinline>
              <source :src="$app_video + 'new_vantage.mp4'" type="video/mp4" />
            </video>
          </div>
        </div>

        <!-- System support -->
        <div class="nav-page__support-box">
          <h2 class="nav-page__box-title">{{ $t('blog.blog5.systemSupport') }}</h2>
          <div class="nav-page__support-grid">
            <div class="nav-page__support-card">
              <div class="nav-page__support-icon nav-page__support-icon--blue">
                <i class="fas fa-robot"></i>
              </div>
              <h3>{{ $t('blog.blog5.EA') }}</h3>
              <p>{{ $t('blog.blog5.ea10') }}</p>
            </div>
            <div class="nav-page__support-card">
              <div class="nav-page__support-icon nav-page__support-icon--teal">
                <i class="fas fa-trophy"></i>
              </div>
              <h3>{{ $t('blog.blog5.masterTop') }}</h3>
              <p>{{ $t('blog.blog5.st') }}</p>
            </div>
            <div class="nav-page__support-card">
              <div class="nav-page__support-icon nav-page__support-icon--purple">
                <i class="fas fa-users"></i>
              </div>
              <h3>{{ $t('blog.blog5.customer6000') }}</h3>
              <p>{{ $t('blog.blog5.parnerActive') }}</p>
            </div>
            <div class="nav-page__support-card">
              <div class="nav-page__support-icon nav-page__support-icon--gold">
                <i class="fas fa-cogs"></i>
              </div>
              <h3>{{ $t('blog.blog5.crm') }}</h3>
              <p>{{ $t('blog.blog5.ecosystem') }}</p>
            </div>
          </div>
        </div>

        <!-- CTA -->
        <div class="nav-page__cta">
          <h2 class="nav-page__cta-title">{{ $t('common.startNow') }}!</h2>
          <p class="nav-page__cta-sub">{{ $t('blog.blog5.inbox') }}</p>
          <a
            href="https://vigco.co/V7Bnq2"
            target="_blank"
            rel="noopener noreferrer"
            class="nav-page__cta-btn"
          >
            <i class="fas fa-external-link-alt"></i>
            {{ $t('common.openAccount') }}
          </a>
          <div class="nav-page__cta-code">
            <p>{{ $t('blog.blog5.code') }}</p>
            <code>SHcapital</code>
          </div>
        </div>

        <!-- Contact -->
        <div class="nav-page__contact">
          <h2 class="nav-page__contact-title" @click="goToContact">{{ $t('common.contactNow') }}</h2>
          <div class="nav-page__contact-grid">
            <a href="https://t.me/songhancapital" target="_blank" rel="noopener noreferrer" class="nav-page__contact-btn nav-page__contact-btn--tg">
              <i class="fab fa-telegram-plane"></i>
              <div>
                <strong>{{ $t('common.telegram') }}</strong>
                <span>@SHC Rim</span>
              </div>
            </a>
            <a href="tel:+84766726416" class="nav-page__contact-btn nav-page__contact-btn--phone">
              <i class="fas fa-phone"></i>
              <div>
                <strong>{{ $t('common.tel') }}</strong>
                <span>+84.766.726.416</span>
              </div>
            </a>
          </div>
        </div>

      </div>
    </main>
  </div>
</template>

<script src="./new-account-vantage.js"></script>
<style src="./new-account-vantage.scss" lang="scss"></style>
